import { TypeManagerDecorator } from "../../../main/type.map.service";
import { Component, Input, ViewEncapsulation, ChangeDetectionStrategy, signal } from "@angular/core";
import { S25Icons } from "../../s25-icon/s25.icon.const";

@TypeManagerDecorator("s25-ng-ingestion-admin-rules")
@Component({
    selector: "s25-ng-ingestion-admin-rules",
    template: `
        <div class="form-rules-section c-margin-bottom--single">
            <div
                class="collapsible-section-header"
                (click)="toggleShowHide()"
                (keydown.enter)="toggleShowHide()"
                (keydown.space)="$event.preventDefault(); toggleShowHide()"
                tabindex="0"
                role="button"
                [attr.aria-expanded]="showHideExpanded()"
            >
                <h3>Show/Hide Field Rules</h3>
                <s25-ng-icon
                    class="collapse-icon"
                    [type]="caretCollapseIcon"
                    [ariaLabel]="false"
                    [size]="20"
                    [style.--icon--rotation-degrees]="showHideExpanded() ? '180deg' : '0deg'"
                />
            </div>
            <div class="collapsible-section-content" [hidden]="!showHideExpanded()">
                <p class="rule-description">
                    Configure rules to dynamically show or hide fields based on user answers.
                </p>
                <s25-ng-rule-tree
                    [category]="'ingestion'"
                    [subCategory]="ingestionPointId?.toString() || ''"
                    [conditionFilterMap]="{ ingestionFieldsAll: ingestionPointId?.toString() || '' }"
                ></s25-ng-rule-tree>
            </div>
        </div>

        <div class="form-rules-section">
            <div
                class="collapsible-section-header"
                (click)="toggleValidation()"
                (keydown.enter)="toggleValidation()"
                (keydown.space)="$event.preventDefault(); toggleValidation()"
                tabindex="0"
                role="button"
                [attr.aria-expanded]="validationExpanded()"
            >
                <h3>Form Validation Rules</h3>
                <s25-ng-icon
                    class="collapse-icon"
                    [type]="caretCollapseIcon"
                    [ariaLabel]="false"
                    [size]="20"
                    [style.--icon--rotation-degrees]="validationExpanded() ? '180deg' : '0deg'"
                />
            </div>
            <div class="collapsible-section-content" [hidden]="!validationExpanded()">
                <p class="rule-description">
                    Configure custom validation rules that check multiple fields and display form-level errors.
                </p>
                <s25-ng-rule-tree
                    [category]="'ingestionValid'"
                    [subCategory]="ingestionPointId?.toString() || ''"
                    [conditionFilterMap]="{ ingestionFieldsAll: ingestionPointId?.toString() || '' }"
                ></s25-ng-rule-tree>
            </div>
        </div>
    `,
    styles: `
        .form-rules-section {
            border: 1px solid var(--color--border);
            border-radius: 8px;
            overflow: hidden;
        }
        .collapsible-section-header {
            background: var(--color--surface-2-bg);
            padding: 16px 20px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            cursor: pointer;
            border-bottom: 1px solid var(--color--border);
        }
        .collapsible-section-header h3 {
            margin: 0;
            color: var(--color--text-muted);
            font-weight: 600;
        }
        .collapse-icon {
            width: 20px;
            height: 20px;
        }
        .collapsible-section-content {
            padding: 20px;
            background: var(--color--surface-bg);
        }
        .rule-description {
            color: #666;
            font-style: italic;
            margin-bottom: 1rem;
            font-size: 0.9rem;
        }
    `,
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class IngestionAdminRulesComponent {
    @Input() ingestionPointId: number;

    readonly caretCollapseIcon = S25Icons.names.caretDown;

    showHideExpanded = signal(true);
    validationExpanded = signal(true);

    toggleShowHide = () => this.showHideExpanded.update((v) => !v);
    toggleValidation = () => this.validationExpanded.update((v) => !v);
}
